<p-messages [(value)]="messages" [enableService]="false">
  <ng-content></ng-content>
</p-messages>
